import { observable, action } from 'mobx'
import Api from '@api/yun_xuan/liteAppApi'
import { hashHistory } from 'react-router'
import { message } from 'hljd'

class Store {
  @observable title = '' //店铺名称
  @observable photos = [] //轮播图
  @observable can_show_recommend = 1 //店铺推荐
  @observable can_show_gift = 1 //到店礼
  @observable can_show_feed = 1 //动态
  @observable can_show_announcement = 1 //公告
  @observable id = ''
  @observable template_id = ''

  @action
  changeField = type => e => {
    this[type] = e.target.value
  }
  @action
  addPhotos = img => {
    this.photos = [...this.photos, { img }]
  }
  @action
  removePhotos = index => {
    this.photos = this.photos.filter((item, i) => i !== index)
  }

  @action
  submit = async () => {
    const {
      title,
      photos,
      can_show_recommend,
      can_show_gift,
      can_show_feed,
      can_show_announcement,
      template_id,
      id
    } = this
    if (title.trim() === '') {
      return message.warn('店铺名称不能为空')
    }
    let { success } = await Api.setConfigApi({
      id,
      template_id,
      ext_json: {
        title,
        photos,
        can_show_recommend,
        can_show_gift,
        can_show_feed,
        can_show_announcement
      }
    })
    if (success) hashHistory.push('/localMerchant/liteApp/audit')
  }

  @action
  cancel = () => {
    hashHistory.push('/localMerchant/liteApp/audit')
  }

  @action
  getInfo = async () => {
    let {
      data: { ext_json, id, template_id }
    } = await Api.getConfigApi()
    const {
      title,
      photos,
      can_show_recommend,
      can_show_gift,
      can_show_feed,
      can_show_announcement
    } =
      ext_json || {}
    this.title = title || ''
    this.photos = photos || []
    this.can_show_announcement = can_show_announcement
    this.can_show_feed = can_show_feed
    this.can_show_gift = can_show_gift
    this.can_show_recommend = can_show_recommend
    this.id = id
    this.template_id = template_id
  }
}
export default new Store()
